export default function uniq(arr) {
  let res = [];
  arr.forEach((value) => {
    if (res.indexOf(value) === -1) {
      res.push(value);
    }
  });
  return res;
}


// WEBPACK FOOTER //
// ./helpers/uniq.js